<template>
    <Dashboard
        :title="__('Edit page', null, $page.props.profile_locale)"
    >
        <Heading
            :label="page.slug == 'lottery' ? __('Lottery', null, $page.props.profile_locale) : page.title"
        />
        <div class="grid lg:grid-cols-3 gap-3">

                <div class="space-y-3 lg:col-span-2">
                    <InputLabel
                        id="page.title"
                        :placeholder="__('Title', null, $page.props.profile_locale)"
                        v-model="form.page.title"
                    />
                    <InputLabel
                        id="top.content"
                        type="quill"
                        :placeholder="__('Content', null, $page.props.profile_locale)"
                        v-model="form.top.content"
                    />
                    <InputLabel
                        id="top.subtitle"
                        :placeholder="__('Subtitle', null, $page.props.profile_locale)"
                        v-model="form.top.subtitle"
                    />
                    <ImageUpload
                        @imagesUploaded="ev => form.top.icons = ev"
                        type="links"
                        :images="form.top.icons.image"
                    />
                    <ul class="grid lg:grid-cols-2 gap-3">
                        <li
                            v-for="(item, key) in form.top.icons.image"
                            :key="item.id"
                            class="flex space-x-3 border-b pb-2 items-center"
                        >
                            <img :src="item.link ? item.link : item.imageBase64" width="80" height="80" />
                            <InputLabel
                                id="icons.link"
                                v-model="form.top.icons.image[key].url"
                                :placeholder="__('Url', null, $page.props.profile_locale)"
                            />
                        </li>
                    </ul>
                </div>
                <div class="flex flex-col">
                    <InputLabel
                        type="file"
                        :label="__('Zdjęcie główne')"
                        id="main"
                        class="w-full mb-3"
                        v-model="form.image"
                    />
                    <img
                        v-if="image || page.options.image"
                        :src="image ? image : (page.options.image ? page.options.image : null)"
                        class="h-72 max-w-full max-h-full object-contain"
                    >
                </div>
                <div class="col-span-full mt-10">
                    <InputLabel
                        id="page.content"
                        type="quill"
                        :placeholder="__('Content', null, $page.props.profile_locale)"
                        v-model="form.page.content"
                    />
                </div>
                <Button
                    @click="save"
                    class="w-min"
                    :class="[
                        form.isDirty ? '' : 'opacity-50'
                    ]"
                >
                    {{__('Save', null, $page.props.profile_locale)}}
                </Button>
        </div>
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import IconLink from 'UI/IconLink';
    import Heading from 'COMP/Heading';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import { useForm } from '@inertiajs/inertia-vue3'
    import ImageUpload from 'UI/ImageUpload';
    import Checkbox from 'UI/Checkbox';
    import { ref, watch } from '@vue/runtime-core';


    export default {
        props: {
            page: [Array, Object],
        },
        components: {
            Dashboard,
            Button,
            SvgIcon,
            InputLabel,
            Heading,
            IconLink,
            ImageUpload,
            Checkbox
        },
        setup(props) {

            const form = useForm({
                page: {
                    content: props.page.content,
                    title: props.page.title,
                },
                top: {
                    content: props.page.options.content,
                    subtitle: props.page.options.subtitle,
                    icons: {
                        image: props.page.options.icons,
                    }
                },
                image: props.page.options.image,
            })
            const image = ref(null);
            const icons = ref([]);

            function save(){
                form.post(route('dashboard.pages.update', props.page.id), {
                    preserveScroll: true,
                })
            }

            watch(() => form.image, (val) => {
                if(val) image.value = URL.createObjectURL(val);
            })
            return {
                form,
                image,
                icons,

                save,
            }
        },

    }
</script>
